import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { ScheduleDetailSaveModel } from '../../schedule-details/models/schedule-detail-save.model';
export const addSchedule = createAction('[Add Schedule] Add Schedule');

export const createSchedule = createAction(
   '[Create Schedule] Create Schedule',
   props<{ schedule: ScheduleDetailSaveModel }>()
);

export const createScheduleSuccess = createAction(
   '[API] Create Schedule Success',
   props<{ scheduleId: number; scheduleName: string | null }>()
);

export const createScheduleFailure = createAction('[API] Create Schedule Failure', props<SingleGraphError>());
